import { Component, Input, ViewEncapsulation } from '@angular/core';
import { OfferCardData } from '../offer-card-data.model';

@Component({
  selector: 'offer-ribbon',
  template: `
    <div *ngIf="data.ribbon_top_card" class="offer-ribbon {{data.ribbon_top_card.type}}">
      <span class="image -eva-3-mr-sm -eva-3-ml-sm"></span>
      <span class="text eva-3-body-1 -eva-3-ellipsis">
        {{data.ribbon_top_card.text}}
      </span>
    </div>
  `,
  styleUrls: ['./offer-ribbon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferRibbonComponent {
  @Input() data: OfferCardData;
}
